export enum TransactionActionTypes {
    GET_PAYMENT = 'GET_PAYMENT',
    SET_PAYMENT = 'SET_PAYMENT',
    GET_PAYMENT_DETAILS = 'GET_PAYMENT_DETAILS',
    SET_PAYMENT_DETAILS = 'SET_PAYMENT_DETAILS',

    DOWNLOAD_CSV = 'DOWLOAD_CSV',
    DOWNLOAD_CSV_FAILURE = 'DOWNLOAD_CSV_FAILURE',
    DOWNLOAD_CSV_SUCCESS = 'DOWNLOAD_CSV_SUCCESS',

    SAVE_TRANSACTION_FILTER = 'SAVE_TRANSACTION_FILTER',
    CLEAR_TRANSACTION_FILTER = 'CLEAR_TRANSACTION_FILTER'
}